/**
 * @flow
 * @relayHash c29be96ffa67b2fcdb017dddb2a61340
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TeamNew_organization$ref = any;
export type TeamNewQueryVariables = {|
  slug: string
|};
export type TeamNewQueryResponse = {|
  +organization: ?{|
    +$fragmentRefs: TeamNew_organization$ref
  |}
|};
export type TeamNewQuery = {|
  variables: TeamNewQueryVariables,
  response: TeamNewQueryResponse,
|};
*/


/*
query TeamNewQuery(
  $slug: ID!
) {
  organization(slug: $slug) {
    ...TeamNew_organization
    id
  }
}

fragment TeamNew_organization on Organization {
  id
  name
  slug
  permissions {
    teamCreate {
      allowed
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "slug",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug",
    "type": "ID!"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "TeamNewQuery",
  "id": null,
  "text": "query TeamNewQuery(\n  $slug: ID!\n) {\n  organization(slug: $slug) {\n    ...TeamNew_organization\n    id\n  }\n}\n\nfragment TeamNew_organization on Organization {\n  id\n  name\n  slug\n  permissions {\n    teamCreate {\n      allowed\n      message\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TeamNewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organization",
        "storageKey": null,
        "args": v1,
        "concreteType": "Organization",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TeamNew_organization",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TeamNewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "organization",
        "storageKey": null,
        "args": v1,
        "concreteType": "Organization",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "slug",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "permissions",
            "storageKey": null,
            "args": null,
            "concreteType": "OrganizationPermissions",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "teamCreate",
                "storageKey": null,
                "args": null,
                "concreteType": "Permission",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "allowed",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "message",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a6920725957e2c19cff5d75a28754752';
module.exports = node;
